import { ensureNotNil, isNotNil } from "client/Misc/utils";
import { MarkSpec, Mark } from "prosemirror-model";

export type LinkMarkAttributes = {
	href: string;
	openInANewWindow?: boolean;
	mentionType?: string;
	mentionValue?: string | null;
};

export const link: MarkSpec = {
	attrs: {
		href: {},
		openInANewWindow: { default: true },
		mentionType: { default: undefined },
		mentionValue: { default: undefined }
	},
	inclusive: false,
	parseDOM: [
		{
			tag: "a[href]",
			getAttrs(dom): LinkMarkAttributes {
				if (!(dom instanceof HTMLAnchorElement)) {
					throw new Error("Expected Node at this point");
				}
				return {
					href: ensureNotNil(dom.getAttribute("href")),
					openInANewWindow: dom.getAttribute("target") === "_blank",
					mentionType: dom.dataset["mention"],
					mentionValue: dom.dataset["value"]
				};
			}
		}
	],
	toDOM(node: Mark) {
		const {
			href,
			openInANewWindow,
			mentionType,
			mentionValue
		} = (node.attrs as LinkMarkAttributes);

		return [
			"a",
			{
				href,
				target: openInANewWindow ? "_blank" : undefined,
				rel: "noopener noreferrer",
				...isNotNil(mentionType)
					? {
						"data-mention": mentionType,
						"data-value": mentionValue ?? null
					}
					: {}
			},
			0
		];
	}
};